import { authHermitHeaders } from 'actions';
import axios from 'axios';
import { authHeaders } from './auth';
import {
    GET_COURIES,
    GET_LOCODES,
    GET_TRACKERS,
    GET_TRACKERS_EVENT,
    GET_TRACKERS_V4
} from './constants'


/** Get Track shipment
* @param {
*      type: string (['BC', 'BL', BK'], default is BC)
*      params: {
*           carrierNo: string,
*           containerNo: string,
*           originCode: string,
*           destCode: string
*     }
*} params
*/
export const getTrackers = (params, token) => {
    return axios.get(GET_TRACKERS, params ? {
        params,
        ...authHeaders(token)
    } : authHeaders(token));
};

export const getTrackAndTraceV2 = (params, token) => {
    params.acl = [];
    return axios.post(GET_TRACKERS_V4, params,authHermitHeaders(token));
};

export const getTrackerEvent = (params, token) => {
    params.acl = [];
    params.requestType = "SHIP_TAT";
    return axios.post(GET_TRACKERS_EVENT, params,authHermitHeaders(token));
};

export const getTrackersV4 = (params, token) => {
    return axios.get(GET_TRACKERS_V4, params ? {
        params,
        ...authHermitHeaders(token)
    } : authHermitHeaders(token));
};

/** Get Carriers
* @param {
*      nameOrCode : string
*      limit: int
* } params
*/
export const getCarriers = (params, token) => {
    return axios.get(process.env.REACT_APP_API_QUIGON, params ? {
        params,
        headers: {
            'Authorization': token,
            'x-api-key': process.env.REACT_APP_QUIGON_KEY

        }
    } : {
        headers: {
            'Authorization': token,
            'x-api-key': process.env.REACT_APP_QUIGON_KEY
        }
    });
};

/** Get Routes
* @param {
*     imo : string,
*     originPort: string, 
*     destinaionPort: string
* } params
*/
export const getRoute = (payload, token) => {
    if (!payload) return;
    return axios.post(GET_TRACKERS_V4, payload, authHeaders(token));
};

/** Get Locodes
* @param {
*      cop : string
*      limit: int
* } params
*/
export const getLocodes = (params, token) => {
    return axios.get(GET_LOCODES, params ? {
        params,
        ...authHeaders(token)
    } : authHeaders(token));
};

/** Get Couriers
* @param {
    *      pageSize : int
    *      pageNo: int, 
    *      search: string
    * } params
    */
    export const getCouriers = (params, token) => {
        return axios.get(GET_COURIES, params ? {
            params,
            ...authHeaders(token)
        } : authHeaders(token));
    };